<template>
  <BtnToggle 
    ref="tool"
    class="tool-text-sucscript"
    :class="{ active: selectionFormat.script == 'sub' }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblSubscript', languageEngine)"
    @click="onClick(!value)"
  >
    <IconTextSubscript/>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";
import IconTextSubscript from "@components_system/Shared/Images/Icon/IconTextSubscript";

export default {
  components: {
    BtnToggle,
    IconTextSubscript,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormat() {
      return this.texteditor.selectionFormat;
    },
    value() {
      if (this.selectionFormat.script == 'super') return false;
      if (this.selectionFormat.script == 'sub') return true;
      return false
    },
  },
  methods: {
    onClick(value) {
      const selection = this.texteditor.editor.getSelection();
      if (value) {
        this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
          script: 'sub'
        });
      } else {
        this.texteditor.editor.formatText({ index: selection.index, length: selection.length }, {
          script: false
        });
      }
    }
  },
}
</script>
<style lang="scss">
.tool-text-sucscript {
  svg {
    margin-top: -3px;
    margin-right: -3px;
  }
  &.active {
    svg {
      path {
        fill: #24BEE2;
      }
    }
  }
}
</style>
